import { css } from 'lit';
export const DocumentDisplayCss = css `
    .document-container {
        border: 2px dashed #ccd0d5;
        border-radius: 8px;
        padding: 24px;
        background-color: #f7f8fa;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease-in-out;
        background-color: #f9fafb;
        width: 100%;
        margin: 0 auto;
    }
    .document-container:hover, .document-container.dragging-over {
        border-color: #1877f2;
        background-color: #e7f3ff;
    }

    .document-container.has-preview {
        display: block;
        padding: 0;
        border: 1px solid #e5e7eb;
    }
    .document-container .content-wrapper {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    .document-container .icon, .document-icon {
        width: 48px; height: 48px;
        color: #1877f2;
        flex-shrink: 0;
    }
    .document-container .details {
        flex-grow: 1;
        text-align: left;
    }
    .document-container .prompt {
        font-weight: 600;
        color: #1c1e21;
    }
    .document-container .support-text, .document-container .file-name {
        font-size: 0.9rem;
        color: #606770;
    }
    .document-container .try-again-button {
        margin-left: auto; /* Pushes button to the right */
        flex-shrink: 0;
    }

    .document-container .loader {
        border: 4px solid #f3f3f3;
        border-top: 4px solid #1877f2;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        animation: spin 1s linear infinite;
        flex-shrink: 0;
    }
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    /* Styles for the preview iframe */
    .document-preview-frame {
        width: 100%;
        aspect-ratio: 8.5 / 11;
        border: 1px solid #ccd0d5;
        border-radius: 4px;
        background-color: #fff;
    }
`;
